import { PatientCaseContent } from './zod';

export enum UserType {
  ALL = 'all',
  GUEST = 'guest',
  HOST = 'host',
  ADMIN = 'admin',
}

export type CaseMap = Record<string, PatientCaseContent>;

export enum MeetingTypes {
  LIVE = 'live',
  ONLINE = 'online',
}

export enum EnvironmentValues {
  TEST = 'test',
  LOCAL = 'local',
  DEV = 'development',
  STAGING = 'staging',
  PROD = 'production',
  SIMULATION = 'simulation',
}

export enum MasterClassSpecialViews {
  CASE_INTRO = 'CASE_INTRO',
  END_SCREEN = 'END_SCREEN',
}
